export default "__VITE_ASSET__uNhDVC5M__"